import * as yup from 'yup';

import {
  LC_PAGE_SUBJECT_CHAR_LIMIT,
  LP_PAGE_MONTESSORI_PREREQUISITES_CHAR_LIMIT,
  LP_PAGE_OBJECTIVE_CHAR_LIMIT,
} from '@lessonPlanner/constants';
import { LessonFormat } from '@lessonPlanner/prompts';

const charLimitTest = (limit: number) => (val: string) =>
  !val || val.length <= limit;

export const gradeLevel = yup.string().required('Please select a grade level');

export const subject = yup
  .string()
  .required('Please enter a subject')
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LC_PAGE_SUBJECT_CHAR_LIMIT),
  );

export const language = yup.string().required('Please select a translation');

export const lessonFormat = yup.string().when('gradeLevel', {
  is: (gradeLevel) => gradeLevel !== 'College',
  then: (schema) =>
    schema
      .required('Lesson Format is required')
      .oneOf(
        [...Object.values(LessonFormat)],
        'Please select a valid lesson format',
      ),
  otherwise: (schema) => schema.nullable(),
});

export const time = yup.string().required('Please select the Time');

export const modality = yup.string().required('Please select the Modality');

export const textArea = yup
  .string()
  .required('Please enter objective')
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LP_PAGE_OBJECTIVE_CHAR_LIMIT),
  );

export const optionalTextArea = yup
  .string()
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LP_PAGE_OBJECTIVE_CHAR_LIMIT),
  );

export const title = yup
  .string()
  .required('Please enter the title.')
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LC_PAGE_SUBJECT_CHAR_LIMIT),
  );

export const prerequisite = yup
  .string()
  .optional()
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LP_PAGE_MONTESSORI_PREREQUISITES_CHAR_LIMIT),
  );

export const montessoriMaterials = yup
  .string()
  .oneOf(
    ['none', 'common-classroom-materials', 'any-materials-available'],
    'Invalid option selected.',
  )
  .required('Please select a value.');

export const optionalKeyArea = yup
  .string()
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LP_PAGE_OBJECTIVE_CHAR_LIMIT),
  );

export const americaCurriculum = yup
  .string()
  .required('Please enter the Curriculum')
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LC_PAGE_SUBJECT_CHAR_LIMIT),
  );

export const americaStandard = yup
  .string()
  .required('Please enter the Standard to be followed')
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LC_PAGE_SUBJECT_CHAR_LIMIT),
  );

export const americaStrategy = yup
  .string()
  .optional()
  .test(
    'len',
    'You have reached the character limit',
    charLimitTest(LC_PAGE_SUBJECT_CHAR_LIMIT),
  );
